<script setup>
  import { useProfileStore } from '@/stores/profile.store'
  import { defineEmits, onMounted, ref, computed, defineProps } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'
  import flags from '@/locales/flags.json'
  import supportedLanguages from "@/locales/languages.json"
  const { t } = useI18n()
  const router = useRouter()

  const profileStore = useProfileStore()
  const emit = defineEmits(['changeLanguage'])
  const loaded = ref(false)
  const isMenuVisible = ref(false)

  // Define the new prop
  const props = defineProps({
    disableChangeLanguage: {
      type: Boolean,
      default: false
    }
  })

  onMounted(async() => {
    await profileStore.fetchProfile(false)
    loaded.value = true
  })
  async function change_learning_language(language) {
    await profileStore.changeLanguage(language)
    emit('changeLanguage', language)
    isMenuVisible.value = false
  }
  function getFlag (language) {
    // check for language to exist as a key in the flags dictionary, if it does, return the value
    // here language is a 2 letter language code like 'ja', 'en', etc.
    // it returns a 2 letter code like 'jp', 'us', etc.
    if (flags[language]) {
      return flags[language].flag
    }
  }
  const profileLanguageCode = computed(() => {
    return supportedLanguages[profileStore.profile.learning_language]
  })
  function languageNameToCode (language) {
    // check for language to exist as a key in the supportedLanguages dictionary, if it does, return the value
    // here language is a 2 letter language code like 'ja', 'en', etc.
    // it returns a 2 letter code like 'jp', 'us', etc.
    if (supportedLanguages[language]) {
      return supportedLanguages[language]
    }
  }

  function toggleMenu() {
    if (!props.disableChangeLanguage) {
      isMenuVisible.value = !isMenuVisible.value
    }
  }

  function navigateToProfile() {
    isMenuVisible.value = false
    router.push({ name: 'ProfileView' })
  }
</script>
<template>
  <span v-if="loaded" class="position-relative">
    <country-flag 
      :country="getFlag(profileLanguageCode)" 
      size="normal" 
      class="mr-2 main-flag" 
      @click="toggleMenu" 
      :class="{ 'disabled-flag': disableChangeLanguage }"
    />

    <div v-if="isMenuVisible" class="popout-menu">
      <ul class="text-start">
        <li 
          v-for="language in profileStore.profile.languages" 
          :key="language.id" 
          :value="language.language" 
          @click="change_learning_language(language.language)" 
          class="d-flex align-items-center"
        >
          <country-flag 
            :country="getFlag(languageNameToCode(language.language))" 
            size="small" 
            class="me-0" 
          /> 
          <span class="nowrap">{{ t(`language.name.${language.language_id}`) }}</span>
        </li>
        <li 
          @click="navigateToProfile" 
          class="d-flex align-items-center add-language-option"
        >
          <span class="add-language-icon me-2">+</span>
          <span class="nowrap">{{ t('language.add-new') }}</span>
        </li>
      </ul>
    </div>
  </span>
</template>

<style scoped>
.main-flag {
  cursor: pointer;
  margin-top: -10px !important;
}

.main-flag.disabled-flag {
  cursor: not-allowed;
  opacity: 0.5;
}

/* Prevent text wrapping */
.nowrap {
  white-space: nowrap;
}

/* Adjust the width of the select element */
.custom-select-width {
  width: auto;
  min-width: 150px; /* Set a reasonable minimum width */
  max-width: 300px; /* Optional: limit the maximum width */
}

/* Styles for the popout menu */
.popout-menu {
  position: absolute;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  /* padding: 10px; */
  z-index: 1000;
  top: 100%; /* Position below the flag */
  left: 0;
}

.popout-menu ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.popout-menu li {
  padding: 10px 25px 10px 20px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  font-size:14px;
  font-weight:500;
}

.popout-menu li:hover {
  background-color: #f1f1f1;
}

.popout-menu country-flag {
  margin-right: 8px;
}
.nowrap {
  white-space: nowrap;
}

.add-language-option {
  border-top: 1px solid #ddd !important;
  border-bottom: none !important;
  background-color: #f8f9fa;
  font-style: italic;
  color: #6c757d;
}

.add-language-option:hover {
  background-color: #e9ecef !important;
}

.add-language-icon {
  font-weight: bold;
  font-size: 18px;
  width: 20px;
  text-align: center;
  color: #007bff;
}
</style>
